/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"
import { BlockText } from "frontend/src/components/BlockText"
import { Logo } from "frontend/src/components/Logo"

function ImageSectionDesktop({ image, title, text, logo, fontColor }) {
  return (
    <div
      sx={{
        display: ["none", "none", "grid"],
        width: "100%",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "3fr 7fr",
      }}
    >
      <Img
        fluid={getFluidFromAsset(image, 2000)}
        sx={{
          width: "100%",
          gridColumn: "1 / span 1",
          gridRow: "1 / span 2",
          height: "100%",
          maxHeight: "550px",
        }}
        imgStyle={{ objectFit: "cover" }}
      />
      <div sx={{ gridColumn: "1 / span 1", gridRow: "2 / span 1", zIndex: 10, height: "100%" }}>
        <h2
          sx={{
            color: fontColor,
            textAlign: "center",
            fontFamily: "heading",
            fontSize: "38px",
            fontWeight: "regular",
            width: "45%",
            maxWidth: "506px",
            minWidth: "400px",
            lineHeight: "44px",
            letterSpacing: "-1.24px",
            mx: "auto",
            mb: 5,
          }}
        >
          {title}
        </h2>
        <BlockText
          blocks={text}
          style={{
            color: fontColor,
            fontFamily: "body",
            fontSize: "22px",
            fontWeight: 300,
            lineHeight: "28px",
            textAlign: "center",
            width: "60%",
            mx: "auto",
            maxWidth: "675px",
            minWidth: "415px",
            mb: 11,
          }}
        />
        <div sx={{ textAlign: "center" }}>
          <Logo name={logo} sx={{ width: "239px" }} />
        </div>
      </div>
    </div>
  )
}

function ImageSectionMobile({ image, title, text, logo, fontColor }) {
  return (
    <div
      sx={{
        display: ["grid", "grid", "none"],
        width: "100%",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr 1fr",
      }}
    >
      <Img
        fluid={getFluidFromAsset(image, 600)}
        sx={{ width: "100%", gridColumn: "1 / span 1", gridRow: "1 / span 2" }}
      />
      <div sx={{ gridColumn: "1 / span 1", gridRow: "2 / span 1", zIndex: 10 }}>
        <h2
          sx={{
            fontFamily: "heading",
            color: fontColor,
            textAlign: "center",
            fontSize: ["28px", "28px", "38px"],
            fontWeight: ["medium", "medium", "regular"],
            lineHeight: ["30px", "30px", "44px"],
            letterSpacing: "-1.24px",
            width: "85%",
            mx: "auto",
            maxWidth: "320px",
            minWidth: "300px",
            mb: 5,
          }}
        >
          {title}
        </h2>
        <BlockText
          blocks={text}
          style={{
            color: fontColor,
            fontFamily: "body",
            fontWeight: 400,
            lineHeight: "140%",
            textAlign: "center",
            mx: "auto",
            mb: 5,
            width: "300px",
          }}
        />
        <div sx={{ textAlign: "center" }}>
          <Logo name={logo} sx={{ width: "183px" }} />
        </div>
      </div>
    </div>
  )
}

function ImageSection({ imageDesktop, imageMobile, title, text, logo, fontColor }) {
  return (
    <SectionGrid sx={{ pt: 8 }}>
      <SectionGrid.wide>
        <ImageSectionDesktop
          image={imageDesktop}
          title={title}
          text={text}
          logo={logo}
          fontColor={fontColor}
        />
        <ImageSectionMobile
          image={imageMobile}
          title={title}
          text={text}
          logo={logo}
          fontColor={fontColor}
        />
      </SectionGrid.wide>
    </SectionGrid>
  )
}

export { ImageSection }
